export const RUN_SIMULATION_REQUEST = 'RUN_SIMULATION_REQUEST';
export const RUN_SIMULATION_FAILURE = 'RUN_SIMULATION_FAILURE';
export const RUN_SIMULATION_SUCCESS = 'RUN_SIMULATION_SUCCESS';
export const INVALIDATE_SIMULATION = 'INVALIDATE_SIMULATION';

function runSimulationRequest() {
  return {
    type: RUN_SIMULATION_REQUEST,
  };
}

function runSimulationFailure(key, error) {
  return {
    type: RUN_SIMULATION_FAILURE,
    payload: { key, error },
  };
}

function runSimulationSuccess(key, simulation) {
  return {
    type: RUN_SIMULATION_SUCCESS,
    payload: { key, simulation },
  };
}

export function invalidateSimulation(key) {
  return {
    type: INVALIDATE_SIMULATION,
    payload: { key },
  };
}

export function runSimulation(key) {
  return (dispatch, getState) => {
    dispatch(runSimulationRequest());

    const { configs } = getState();
    const config = configs.byKey[key];

    return fetch('/api/simulations', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ config }),
      credentials: 'include', // Make sure we send and receive any cookies
    })
      .then(
        response => {
          if (!response.ok) {
            const error = new Error(response.statusText);
            error.status = response.status;
            throw error;
          }

          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            return response.json();
          }

          throw new Error('Invalid content type ' +
            response.headers.get('content-type'));
        },
        error => dispatch(runSimulationFailure(key, error))
      )
      .then(
        simulation => dispatch(runSimulationSuccess(key, simulation)),
        error => dispatch(runSimulationFailure(key, error))
      );
  };
}



// WEBPACK FOOTER //
// ./client/src/actions/simulations.js